import React, { useContext } from 'react'
import { DiscountRulesServiceContext } from 'discounts/rules/context'
import { DiscountRulesContext } from 'discounts/rules/table/tableContext'
import { DiscountRule } from 'discounts/rules/discountRulesService'
import { Toggle } from 'uiComponents/input/toggle'
import { MetadataContext } from 'discounts/rules/metadataContext'
import { useTranslation } from 'translations'

interface InlineNameProps {
    rule: DiscountRule
}

function StatusCell({ rule }: InlineNameProps) {
    const { t } = useTranslation()
    const discountRulesService = useContext(DiscountRulesServiceContext)
    const { reloadData } = useContext(DiscountRulesContext)
    const { accountSlug, replaceMessages } = useContext(MetadataContext)

    const toggleEnabled = async (ruleId: number) => {
        try {
            await discountRulesService.updateDiscountRuleStatus(accountSlug, ruleId, !rule.enabled)
            reloadData()
        } catch {
            replaceMessages('email_error', 'error', t('products.discountRules.table.statusError'))
        }
    }

    return (
        <>
            {t('products.discountRules.form.activate')}
            <Toggle
                isOn={rule.enabled}
                onClick={() => toggleEnabled(rule.id)}
                className="smallInlineToggle"
                style={{ marginLeft: '0.7rem' }}
            />
        </>
    )
}

export default StatusCell
